module.exports = __webpack_public_path__ + "static/media/mastercard.ecfd04c7.svg";